var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88235 0.75C6.83375 0.75 4.30159 2.80572 3.43199 5.57445C1.71944 6.40074 0.5 8.10995 0.5 10.1324C0.5 12.9477 2.80228 15.25 5.61765 15.25H15.8529C18.6683 15.25 20.9706 12.9477 20.9706 10.1324C20.9706 7.42027 18.8216 5.22794 16.1461 5.06801C15.1366 2.55917 12.7444 0.75 9.88235 0.75ZM9.88235 2.45588C12.2146 2.45588 14.1637 4.01183 14.7868 6.13419L14.9733 6.7739L15.6664 6.74724C15.8496 6.73725 15.9029 6.72059 15.8529 6.72059C17.7487 6.72059 19.2647 8.23656 19.2647 10.1324C19.2647 12.0248 17.7487 13.5441 15.8529 13.5441H5.61765C3.72185 13.5441 2.20588 12.0248 2.20588 10.1324C2.20588 8.67302 3.11213 7.45358 4.39154 6.96048L4.81802 6.80055L4.92463 6.37408C5.46772 4.13511 7.4668 2.45588 9.88235 2.45588ZM9.02941 5.86765V9.27941H7.53677L9.88235 12.4779L12.2279 9.27941H10.7353V5.86765H9.02941Z",
    fill: "#0F5BF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloud);
export default __webpack_public_path__ + "static/media/DownloadCloud.a1147d45513ee84c03ab0e2e17c326fd.svg";
export { ForwardRef as ReactComponent };